import { Controller } from "@hotwired/stimulus";

// Post embeds are bare iframes, with none of the networks' scripts on the page (see
// react/components/embedProviders.ts). The frames whose height depends on the content —
// Instagram and X — report it through postMessage; this applies it. Without a message the
// frame keeps the fallback height from tiptap_editor.css.
//
// Facebook's post plugin lays out at a fixed pixel width (350–500 here), so on a narrow screen
// the frame is pointed at a width that fits before it loads.
export default class extends Controller {
  connect() {
    this.handleMessage = (event) => this.resize(event);
    window.addEventListener("message", this.handleMessage);
    this.fitFacebookPosts();
  }

  disconnect() {
    window.removeEventListener("message", this.handleMessage);
  }

  resize(event) {
    const height = reportedHeight(event);
    if (!height) return;

    const iframe = [...this.element.querySelectorAll(".post-embed iframe")].find(
      (frame) => frame.contentWindow === event.source,
    );
    if (iframe) iframe.style.height = `${Math.ceil(height)}px`;
  }

  fitFacebookPosts() {
    this.element
      .querySelectorAll('.post-embed[data-embed="facebook"][data-embed-layout="post"] iframe')
      .forEach((iframe) => {
        const width = Math.round(Math.min(500, Math.max(350, iframe.clientWidth)));
        const url = new URL(iframe.src);
        if (url.searchParams.get("width") === String(width)) return;

        url.searchParams.set("width", String(width));
        iframe.src = url.toString();
      });
  }
}

function reportedHeight(event) {
  let data = event.data;
  if (typeof data === "string") {
    try {
      data = JSON.parse(data);
    } catch {
      return null;
    }
  }
  if (!data || typeof data !== "object") return null;

  if (event.origin === "https://www.instagram.com" && data.type === "MEASURE") {
    return Number(data.details?.height) || null;
  }

  if (event.origin === "https://platform.twitter.com") {
    const embed = data["twttr.embed"];
    if (embed?.method === "twttr.private.resize") return Number(embed.params?.[0]?.height) || null;
  }

  return null;
}
